// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + ({"17":"activityDetailsView","962":"home"}[chunkId] || chunkId) + "." + {"17":"343c38d9","857":"6aade2d9","962":"418fbce3"}[chunkId] + ".chunk.css";
};